//
//
//
//
//
//
//
//
//
//
//
//
//

import {base, prefix} from '../../common/mixins'

const directions = ['up', 'left', 'right', 'down']

export default {
  name: 'TopTip',
  mixins: [base, prefix],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    entryDirection: {
      type: String,
      default: 'left',
    },
  },
  data () {
    return {
      show: false,
    }
  },
  computed: {
    transition () {
      return directions.includes(this.entryDirection)
        ? this.b(`slide-in-${this.entryDirection}`)
        : this.b('slide-in-left')
    },
  },
  watch: {
    value (val) {
      this.show = val
    },
  },
  created () {
    if(this.value) {
      this.show = this.value
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/TopTip/index.vue